import { object, element, bool, func, number, string } from 'prop-types'
import { Component } from 'react'
import { kuiperClassNames, PopoverV2, InputV2 } from '@opallabs/kuiper'
import { Button } from '@opallabs/lapidary'
import { AnalyticsLayer } from '@opallabs/quanta'
import './styles.scss'

class RenamePopover extends Component {
  static propTypes = {
    closePopover: func,
    entity: object,
    isOpen: bool,
    label: string,
    maxLength: number,
    renameEntity: func,
    trigger: element,
  }

  static defaultProps = {
    maxLength: 50,
  }

  constructor(props) {
    super(props)

    this.state = {
      newName: props.entity.name,
    }
  }

  componentDidMount() {
    document.addEventListener('contextmenu', this.globalRightClickHandler)
  }

  componentWillUnmount() {
    document.removeEventListener('contextmenu', this.globalRightClickHandler)
  }

  globalRightClickHandler = () => {
    this.props.closePopover()
  }

  shouldDisableSubmitButton() {
    const { newName } = this.state
    return newName.length === 0 || newName.length > this.props.maxLength
  }

  onCancel = () => {
    this.props.closePopover()
  }

  onSubmit = () => {
    const { renameEntity, entity, closePopover } = this.props
    renameEntity(entity.id, this.state.newName)
    closePopover()
  }

  handleKeyDown = (code) => {
    if (code === 13) {
      return this.onSubmit()
    }

    return this.onCancel()
  }

  renderInternals = () => (
    <AnalyticsLayer name="Rename Popover">
      <p className={kuiperClassNames('inputText')}>{this.props.label}</p>
      <InputV2
        aside={true}
        className={kuiperClassNames('popover-input')}
        focusOnMount={true}
        maxLength={this.props.maxLength}
        onChange={(val) => {
          this.setState({ newName: val })
        }}
        theme="light"
        triggerOnKeyPress={{
          keyCodes: [13, 27],
          triggerFunction: (code) => this.handleKeyDown(code),
        }}
        value={this.state.newName}
      />
      <div className={kuiperClassNames('buttons')}>
        <Button buttonText="Cancel" variant="ghost" onClick={this.onCancel} />
        <Button
          disabled={this.shouldDisableSubmitButton()}
          buttonText="Save"
          variant="primary"
          onClick={this.onSubmit}
        />
      </div>
    </AnalyticsLayer>
  )

  render() {
    const { isOpen, closePopover, trigger } = this.props

    return (
      <PopoverV2
        className={kuiperClassNames('rename-popover')}
        onClose={closePopover}
        position="bottom"
        popoverHandlers={{
          open: isOpen,
          hideOnClick: true,
          appendTo: () => document.body,
        }}
        trigger={trigger}
        triggerEvent="manual"
        content={this.renderInternals()}
        edgeOffset={0}
      />
    )
  }
}

export default RenamePopover
